// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.egSAx8PmpieX3e {
  /* stylelint-disable-next-line declaration-no-important */
  width: 100% !important;
}
`, ""]);
// Exports
export var dialog = `egSAx8PmpieX3e`;
export default ___CSS_LOADER_EXPORT___;
